import { useState } from 'react';

import { Button } from '@/components/ui/button.tsx';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog.tsx';
import { type CategoryType, HumanizedCategories } from '@/types/product.type.ts';

type Props = {
  categoryType: CategoryType;
  onSkip: () => void;
};

export default function SkipButton({ categoryType, onSkip }: Props) {
  const [isConfirming, setIsConfirming] = useState(false);
  const humanizedCategory = HumanizedCategories[categoryType] ?? categoryType;

  return (
    <>
      <Button variant="outline" onClick={() => setIsConfirming(true)}>
        Skip
      </Button>

      <Dialog open={isConfirming} onOpenChange={setIsConfirming}>
        <DialogContent showCloseButton={false}>
          <DialogHeader>
            <DialogTitle>Are you sure you want to skip {humanizedCategory}?</DialogTitle>
          </DialogHeader>

          <p className="text-charcoal-900">
            If you change you mind, you can always give us a call.
          </p>

          <div className="grid grid-cols-[1fr_2fr] gap-3">
            <Button variant="outline" onClick={() => setIsConfirming(false)}>
              No
            </Button>
            <Button onClick={onSkip}>Yes, skip</Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
